import $ from 'jquery';


	$( '.article-overview__slider' ).slick( {
		infinite: true,
		dots: true,
		variableWidth: true,
		initialSlide: 0,
		swipeToSlide: true,
		autoplay: true,
		prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
		nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
	} );



